import { apiClientBlob } from "@/services/ApiClient";

export function exportActions(path) {
  const exportExcelItems = criteria => apiClientBlob.post(`${path}/items/export`, criteria);

  return { exportExcelItems };
}
